import script from "./NosDernieresOffres.vue?vue&type=script&setup=true&lang=js"
export * from "./NosDernieresOffres.vue?vue&type=script&setup=true&lang=js"

import "./NosDernieresOffres.vue?vue&type=style&index=0&id=f530182e&lang=css"

const __exports__ = script;

export default __exports__